// extracted by mini-css-extract-plugin
export default {"drawerTitle":"drawerTitle--uZRQF","tableModule":"tableModule--HMLOP","specialTable":"specialTable--UAq3x","markerAnimationScale":"markerAnimationScale--fWtnd"};